import React, { useState } from 'react';
import { Plus, Search, MoreHorizontal, FileText, Car } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../components/ui/DropdownMenu';
import { mockClients, mockVehicles } from '../data/mockData';
import { formatPhone, formatDate } from '../lib/utils';
import { Avatar, AvatarFallback } from '../components/ui/Avatar';
import { Link } from 'react-router-dom';
export function Clients() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredClients = mockClients.filter(client => client.name.toLowerCase().includes(searchTerm.toLowerCase()) || client.document.includes(searchTerm) || client.phone.includes(searchTerm));
  return <div className="h-full flex flex-col space-y-6" data-id="element-382">
      <div className="flex items-center justify-between" data-id="element-383">
        <div data-id="element-384">
          <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-385">
            Clientes
          </h1>
          <p className="text-muted-foreground mt-1" data-id="element-386">
            Gerencie sua carteira de clientes.
          </p>
        </div>
        <Button className="gap-2" data-id="element-387">
          <Plus className="h-4 w-4" data-id="element-388" /> Novo Cliente
        </Button>
      </div>

      <div className="flex items-center gap-2 max-w-md" data-id="element-389">
        <div className="relative flex-1" data-id="element-390">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" data-id="element-391" />
          <Input placeholder="Buscar por nome, CPF/CNPJ ou telefone..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-392" />
        </div>
      </div>

      <div className="rounded-xl border bg-card flex-1 overflow-hidden flex flex-col" data-id="element-393">
        <div className="flex-1 overflow-auto" data-id="element-394">
          <Table data-id="element-395">
            <TableHeader data-id="element-396">
              <TableRow data-id="element-397">
                <TableHead data-id="element-398">Cliente</TableHead>
                <TableHead data-id="element-399">Contato</TableHead>
                <TableHead data-id="element-400">Documento</TableHead>
                <TableHead data-id="element-401">Veículos</TableHead>
                <TableHead data-id="element-402">Cliente desde</TableHead>
                <TableHead className="w-[50px]" data-id="element-403"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-404">
              {filteredClients.map(client => {
              const clientVehicles = mockVehicles.filter(v => v.clientId === client.id);
              const initials = client.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
              return <TableRow key={client.id} data-id="element-405">
                    <TableCell data-id="element-406">
                      <Link to={`/app/clientes/${client.id}`} className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-407">
                        <Avatar className="h-9 w-9" data-id="element-408">
                          <AvatarFallback className="bg-primary/10 text-primary" data-id="element-409">
                            {initials}
                          </AvatarFallback>
                        </Avatar>
                        <div data-id="element-410">
                          <div className="font-medium text-primary hover:underline" data-id="element-411">
                            {client.name}
                          </div>
                          <div className="text-xs text-muted-foreground" data-id="element-412">
                            {client.email}
                          </div>
                        </div>
                      </Link>
                    </TableCell>
                    <TableCell data-id="element-413">{formatPhone(client.phone)}</TableCell>
                    <TableCell data-id="element-414">{client.document}</TableCell>
                    <TableCell data-id="element-415">
                      <div className="flex items-center gap-1 text-muted-foreground" data-id="element-416">
                        <Car className="h-4 w-4" data-id="element-417" />
                        <span data-id="element-418">{clientVehicles.length}</span>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-419">{formatDate(client.createdAt)}</TableCell>
                    <TableCell data-id="element-420">
                      <DropdownMenu data-id="element-421">
                        <DropdownMenuTrigger asChild data-id="element-422">
                          <Button variant="ghost" className="h-8 w-8 p-0" data-id="element-423">
                            <span className="sr-only" data-id="element-424">Abrir menu</span>
                            <MoreHorizontal className="h-4 w-4" data-id="element-425" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" data-id="element-426">
                          <DropdownMenuLabel data-id="element-427">Ações</DropdownMenuLabel>
                          <DropdownMenuItem asChild className="gap-2 cursor-pointer" data-id="element-428">
                            <Link to={`/app/clientes/${client.id}`} data-id="element-429">
                              <FileText className="h-4 w-4" data-id="element-430" /> Ver Detalhes
                            </Link>
                          </DropdownMenuItem>
                          <DropdownMenuItem className="gap-2" data-id="element-431">
                            <Car className="h-4 w-4" data-id="element-432" /> Adicionar Veículo
                          </DropdownMenuItem>
                          <DropdownMenuSeparator data-id="element-433" />
                          <DropdownMenuItem className="text-destructive focus:text-destructive" data-id="element-434">
                            Excluir
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>;
            })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>;
}